<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">用户管理</div>
    </div>
    <div class="nav2">
      <div class="tit1">
        <el-button @click="AddSaishi" size="small" type="primary" icon="el-icon-plus">添加用户</el-button>
        <el-tag 
          :class="{ 'active-filter': todayActiveFilter }" 
          @click="toggleTodayActiveFilter" 
          style="cursor: pointer;">
          日活:{{todayActiveCount}}
        </el-tag>
        <el-tag 
          :class="{ 'active-filter': monthActiveFilter }" 
          @click="toggleMonthActiveFilter" 
          style="cursor: pointer;">
          月活:{{monthActiveCount}}
        </el-tag>
        
        <!-- 添加搜索框 -->
        <el-input
          v-model="searchUserName"
          placeholder="请输入账号/姓名搜索"
          style="width: 250px; margin-left: 10px"
          size="small"
          clearable
          @clear="handleSearch"
          @input="handleSearch">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </div>
      <div class="myTable">
        <vxe-table :loading="loading" align="center" :data="currentPageData">
          <vxe-table-column field="userName" width="110" title="账号"></vxe-table-column>
          <vxe-table-column field="nickName" width="110" title="姓名"></vxe-table-column>
          <vxe-table-column field="createTime" width="150" title="创建时间"></vxe-table-column>
          <vxe-table-column field="expireDate" width="100" title="到期日期"></vxe-table-column>
          <!-- <vxe-table-column field="searchMax" title="限额"></vxe-table-column> -->
          <!-- <vxe-table-column field="searchCount" title="累计次数"></vxe-table-column> -->
          <vxe-table-column field="balance" title="余额" width="140"></vxe-table-column>
          <vxe-table-column title="余额操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="openBalanceChange(scope.row, 'recharge')">充值</el-button>
              <el-button type="text" @click="openBalanceChange(scope.row, 'refund')">退款</el-button>
              <el-button v-if="false" type="text" @click="openBalanceLogs(scope.row)">明细</el-button>
            </template>
          </vxe-table-column>
          <vxe-table-column field="onlinePostCount" title="在招数量">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                @click="showPostsDetail(scope.row)" 
                :disabled="!scope.row.onlinePostCount || scope.row.onlinePostCount === 0"
                style="color: #409EFF;">
                {{ scope.row.onlinePostCount || 0 }}
              </el-button>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="启用状态">
            <template slot-scope="scope">
              <el-switch
                  @change="changeUserStatus($event,scope.row)"
                  :value="scope.row.status==0"
                  active-text=""
                  inactive-text=""
              ></el-switch>
            </template>
          </vxe-table-column>
          <vxe-table-column field="pv1" title="今日登录"></vxe-table-column>
          <vxe-table-column field="pv7" title="7日登录"></vxe-table-column>
          <vxe-table-column field="pv30" title="30日登录"></vxe-table-column>
          <vxe-table-column field="resumedbShow" title="猎聘类型">
            <template slot-scope="scope">
              <el-switch
                  @change="changeUserResumedbShow($event,scope.row)"
                  :value="scope.row.resumedbShow==1"
                  active-text=""
                  inactive-text=""
              ></el-switch>
            </template>
          </vxe-table-column>
          <vxe-table-column field="resumedbEnable" title="网站简历可见">
            <template slot-scope="scope">
              <el-switch
                  @change="changeUserResumedbEnable($event,scope.row)"
                  :value="scope.row.resumedbEnable==1"
                  active-text=""
                  inactive-text=""
              ></el-switch>
            </template>
          </vxe-table-column>
          <vxe-table-column field="aiEnable" title="启用AI">
            <template slot-scope="scope">
              <el-switch
                  @change="changeUserAiEnable($event,scope.row)"
                  :value="Boolean(scope.row.aiEnable)"
                  active-text=""
                  inactive-text=""
              ></el-switch>
            </template>
          </vxe-table-column>
<!--           <vxe-table-column field="email" title="邮箱"></vxe-table-column>-->
<!--           <vxe-table-column field="phonenumber" title="手机"></vxe-table-column>-->

          <vxe-table-column field="resumeDelete" title="简历删除">
            <template slot-scope="scope">
              <el-switch
                  @change="changeUserResumeDelete($event,scope.row)"
                  :value="scope.row.resumeDelete==1"
                  active-text=""
                  inactive-text=""
              ></el-switch>
            </template>
          </vxe-table-column>

          <vxe-table-column field="resumeExport" title="简历导出">
            <template slot-scope="scope">
              <el-switch
                  @change="changeUserResumeExport($event,scope.row)"
                  :value="scope.row.resumeExport==1"
                  active-text=""
                  inactive-text=""
              ></el-switch>
            </template>
          </vxe-table-column>

          <vxe-table-column title="权限设置" width="120">
            <template slot-scope="scope">
              <el-button 
                size="small" 
                type="text" 
                @click="showPermissionDialog(scope.row)">
                权限设置({{ getPermissionCount(scope.row) }})
              </el-button>
            </template>
          </vxe-table-column>

          <vxe-table-column title="操作" width="180">
            <template slot-scope="scope">
              <div class="flex">
                <el-button size="small" type="text" @click="toEdit(scope.row)">修改</el-button>
                <el-button size="small" type="text" @click="toResetPass(scope.row)">重置密码</el-button>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="tips" title="安全提示"></vxe-table-column>
          <vxe-table-column field="siteStats" width="200" title="网站">
            <template slot-scope="scope">
              <el-button 
                v-if="hasSiteStats(scope.row)" 
                type="text" 
                size="small"
                @click="showSiteStatsDetail(scope.row)"
                style="color: #409EFF;">
                {{ formatSiteStats(scope.row.siteStats) }}
              </el-button>
              <span v-else style="color: #999;">-</span>
            </template>
          </vxe-table-column>
        </vxe-table>
        <el-pagination 
          class="fenye" 
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange"
          :current-page="currentPage" 
          :page-size="pageSize" 
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper" 
          :total="filteredTotal">
        </el-pagination>
      </div>
    </div>
    <!-- 添加/修改广告 -->
    <el-dialog title="添加/修改用户" :visible.sync="addDialogVisible" width="700px" :before-close="addHandleClose">
      <div class="myAddForm">
        <el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px" class="demo-addForm">
          <el-row>
            <el-col :span="20">
              <el-form-item label="登录账号" prop="userName">
                <el-input size="small" placeholder="请输入登录账号,可以是手机号或邮箱或自定义" v-model="addForm.userName" :disabled="!isAdd"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="密码" prop="password" v-if="isAdd">
                <el-input size="small" placeholder="请输入密码" v-model="addForm.password"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="公司" prop="company">
                <el-input size="small" placeholder="请输入公司" v-model="addForm.company"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="姓名" prop="nickName">
                <el-input size="small" placeholder="请输入姓名" v-model="addForm.nickName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="职务" prop="job">
                <el-input size="small" placeholder="请输入职务" v-model="addForm.job"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="到期日期" prop="expireDate">
                <el-date-picker
                    v-model="addForm.expireDate"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择到期日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="限额" prop="searchMax">
                <el-input-number v-model="addForm.searchMax" :step=100 :min=0 :max=1000000></el-input-number>
<!--                <el-input size="small" placeholder="请输入限额" v-model="addForm.searchMax"></el-input>-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="网站额度" prop="siteQuota">
                <el-input-number v-model="addForm.siteQuota" :step="100" :min="0" :max="1000000"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="累计次数" prop="searchCount">
                <el-input disabled size="small" placeholder="" v-model="addForm.searchCount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="邮箱" prop="email">
                <el-input size="small" placeholder="请输入邮箱" v-model="addForm.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="手机" prop="mobile">
                <el-input size="small" placeholder="请输入手机" v-model="addForm.phoneNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="列表模型" prop="listModel">
                <el-select size="small" filterable v-model="addForm.listModel" placeholder="从模型价格中选择" style="width: 100%">
                  <el-option v-for="item in modelOptions" :key="'l-' + item.model" :label="item.model" :value="item.model"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="详情模型" prop="detailModel">
                <el-select size="small" filterable v-model="addForm.detailModel" placeholder="从模型价格中选择" style="width: 100%">
                  <el-option v-for="item in modelOptions" :key="'d-' + item.model" :label="item.model" :value="item.model"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item v-if="!isAdd" label="余额" prop="balance">
                <el-input size="small" v-model="addForm.balance"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="API KEY" prop="apiKey">
                <el-input size="small" placeholder="火山/豆包 API Key" v-model="addForm.apiKey"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item>
                <el-button size="small" type="primary" @click="AddOnSubmit('addForm')">提交</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog :title="balanceChangeTitle" :visible.sync="balanceChangeVisible" width="420px">
      <div style="margin-bottom: 12px;">当前余额：{{ balanceChangeCurrent }}</div>
      <el-input v-model="balanceChangeAmount" size="small" placeholder="金额，单位元"></el-input>
      <span slot="footer">
        <el-button size="small" @click="balanceChangeVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="balanceChangeLoading" @click="submitBalanceChange">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="logTitle" :visible.sync="logVisible" width="90%">
      <el-table :data="logRows" v-loading="logLoading" size="mini">
        <el-table-column prop="postName" label="岗位" width="120"></el-table-column>
        <el-table-column prop="typeName" label="类型" width="160"></el-table-column>
        <el-table-column prop="time" label="时间" width="160"></el-table-column>
        <el-table-column prop="resumeName" label="简历" width="100"></el-table-column>
        <el-table-column prop="model" label="模型" width="140"></el-table-column>
        <el-table-column prop="inputToken" label="输入tokens" width="110"></el-table-column>
        <el-table-column prop="outputToken" label="输出tokens" width="110"></el-table-column>
        <el-table-column prop="inputUnitPrice" label="输入单价" width="100"></el-table-column>
        <el-table-column prop="outputUnitPrice" label="输出单价" width="100"></el-table-column>
        <el-table-column prop="inputCost" label="输入消费" width="120"></el-table-column>
        <el-table-column prop="outputCost" label="输出消费" width="120"></el-table-column>
        <el-table-column prop="subtotal" label="小计" width="120"></el-table-column>
        <el-table-column prop="balance" label="余额" width="140"></el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 12px"
        layout="total, prev, pager, next"
        :current-page="logPage"
        :page-size="logPageSize"
        :total="logTotal"
        @current-change="changeLogPage">
      </el-pagination>
    </el-dialog>
    
    <!-- 在招岗位列表弹窗 -->
    <el-dialog 
      title="在招岗位列表" 
      :visible.sync="postsDialogVisible" 
      width="1200px" 
      :before-close="postsHandleClose">
      <div class="posts-dialog-header">
        <span>用户：<strong>{{ currentUserName }}</strong></span>
        <span style="margin-left: 20px;">在招数量：<strong style="color: #409EFF;">{{ postsList.length }}</strong></span>
      </div>
      <vxe-table 
        :loading="postsLoading" 
        align="center" 
        :data="postsList"
        height="500"
        border
        stripe>
        <vxe-table-column type="seq" width="60" title="序号" fixed="left"></vxe-table-column>
        <vxe-table-column field="customer_name" width="180" title="公司名称" fixed="left"></vxe-table-column>
        <vxe-table-column field="post_name" width="200" title="岗位名称" fixed="left"></vxe-table-column>
        <vxe-table-column field="wantdqs" width="150" title="工作地点"></vxe-table-column>
        <vxe-table-column field="salary_range" width="150" title="薪资范围"></vxe-table-column>
        <vxe-table-column field="first_degree" width="100" title="第一学历"></vxe-table-column>
        <vxe-table-column field="addtime" width="170" title="创建时间">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.addtime) }}
          </template>
        </vxe-table-column>
        <vxe-table-column title="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="showPostDetail(scope.row)">详情</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </el-dialog>

    <!-- 岗位详细信息弹窗 -->
    <el-dialog 
      title="岗位详细信息" 
      :visible.sync="postDetailDialogVisible" 
      width="90%" 
      :before-close="postDetailHandleClose"
      top="5vh">
      <div class="post-detail-container">
        <el-form label-width="200px" class="post-detail-form" size="small">
          <!-- 基本信息 -->
          <div class="form-section">
            <div class="section-title">基本信息</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="ID:">
                  <span>{{ currentPost.id }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="岗位ID:">
                  <span>{{ currentPost.post_id }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户ID:">
                  <span>{{ currentPost.customer_id }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="公司用户ID:">
                  <span>{{ currentPost.com_userid }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="创建用户ID:">
                  <span>{{ currentPost.create_userid }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="人选标准:">
                  <span>{{ currentPost.resume_type }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="客户名称:">
                  <span>{{ currentPost.customer_name }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="岗位名称:">
                  <span class="highlight-text">{{ currentPost.post_name }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="岗位全名:">
                  <span>{{ currentPost.postFullName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="工作地点:">
                  <span>{{ currentPost.work_place }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="创建时间:">
                  <span>{{ formatDateTime(currentPost.addtime) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="编辑时间:">
                  <span>{{ formatDateTime(currentPost.edittime) }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="状态:">
                  <el-tag :type="currentPost.status == 4 ? 'success' : 'info'" size="small">
                    {{ currentPost.status }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 薪资信息 -->
          <div class="form-section">
            <div class="section-title">薪资信息</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="薪资范围:">
                  <span class="highlight-text">{{ currentPost.salary_range }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最低薪资(K):">
                  <span>{{ currentPost.min_salary }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最高薪资(K):">
                  <span>{{ currentPost.max_salary }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="薪资倍数(月薪):">
                  <span>{{ currentPost.salaries }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="年薪:">
                  <span>{{ currentPost.years_salaries }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 行业信息 -->
          <div class="form-section">
            <div class="section-title">行业信息</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="行业IDs(猎聘):">
                  <span class="highlight-text">{{ currentPost.industry_ids }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="行业名称(猎聘):">
                  <span>{{ currentPost.industry_name_liepin }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="行业IDs(智联):">
                  <span>{{ currentPost.industry_name_zhilian_ids }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="行业名称(智联):">
                  <span>{{ currentPost.industry_name_zhilian }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="行业关键词1:">
                  <span>{{ currentPost.industry_keywords1 }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="行业关键词2:">
                  <span>{{ currentPost.industry_keywords2 }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="公司规模:">
                  <span>{{ currentPost.company_size }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="公司规模(JSON):">
                  <span>{{ currentPost.company_size_json }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="目标公司:">
                  <el-input type="textarea" :rows="2" v-model="currentPost.target_company" placeholder="请输入目标公司"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="回避公司:">
                  <span class="danger-text">{{ currentPost.huibi_companys }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 岗位分类信息 -->
          <div class="form-section">
            <div class="section-title">岗位分类信息</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="岗位分类IDs(猎聘):">
                  <span class="highlight-text">{{ currentPost.position_classificationids }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="岗位分类名称(猎聘):">
                  <span>{{ currentPost.position_classification_liepin }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="岗位分类IDs(智联):">
                  <span>{{ currentPost.position_classification_zhilian_ids }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="岗位分类名称(智联):">
                  <span>{{ currentPost.position_classification_zhilian }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="岗位职层:">
                  <span>{{ ['','基层','中层','高层','核心高层'][currentPost.postlevel] || '未设置' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="岗位名称关键词:">
                  <el-input type="textarea" :rows="2" v-model="currentPost.postname_keywords" placeholder="请输入岗位名称关键词"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="岗位职级关键词:">
                  <el-input type="textarea" :rows="2" v-model="currentPost.jobtitle_keywords" placeholder="请输入岗位职级关键词"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 地域要求 -->
          <div class="form-section">
            <div class="section-title">地域要求</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="居住地IDs(猎聘):">
                  <span class="highlight-text">{{ currentPost.nowdq_ids }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="居住地名称:">
                  <span>{{ currentPost.nowdqs }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="居住地IDs(智联):">
                  <span>{{ currentPost.nowdq_zhilian_ids }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="期望工作地IDs(猎聘):">
                  <span class="highlight-text">{{ currentPost.wantdq_ids }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="期望工作地名称:">
                  <span>{{ currentPost.wantdqs }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="期望工作地IDs(智联):">
                  <span>{{ currentPost.wantdq_zhilian_ids }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 职责范围 -->
          <div class="form-section">
            <div class="section-title">职责范围</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="职责范围1(任意/全部):">
                  <el-tag :type="currentPost.is_scope1 == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.is_scope1 == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职责关键词1:">
                  <span>{{ currentPost.scope1_keywords }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职责范围2(任意/全部):">
                  <el-tag :type="currentPost.is_scope2 == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.is_scope2 == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="职责关键词2:">
                  <span>{{ currentPost.scope2_keywords }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职责范围3(任意/全部):">
                  <el-tag :type="currentPost.is_scope3 == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.is_scope3 == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职责关键词3:">
                  <span>{{ currentPost.scope3_keywords }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 经验要求 -->
          <div class="form-section">
            <div class="section-title">经验要求</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="专业经验(R1):">
                  <el-input type="textarea" :rows="2" v-model="currentPost.post_r1" placeholder="请输入专业经验(R1)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="范围:">
                  <el-tag :type="currentPost.post_r1_scope == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.post_r1_scope == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="否决:">
                  <el-tag :type="currentPost.post_r1_false == 1 ? 'danger' : 'success'" size="small">
                    {{ currentPost.post_r1_false == 1 ? '是' : '否' }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="业务背景(R2):">
                  <el-input type="textarea" :rows="2" v-model="currentPost.post_r2" placeholder="请输入业务背景(R2)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="范围:">
                  <el-tag :type="currentPost.post_r2_scope == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.post_r2_scope == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="否决:">
                  <el-tag :type="currentPost.post_r2_false == 1 ? 'danger' : 'success'" size="small">
                    {{ currentPost.post_r2_false == 1 ? '是' : '否' }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="资源类型(R3):">
                  <el-input type="textarea" :rows="2" v-model="currentPost.post_r3" placeholder="请输入资源类型(R3)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="范围:">
                  <el-tag :type="currentPost.post_r3_scope == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.post_r3_scope == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="否决:">
                  <el-tag :type="currentPost.post_r3_false == 1 ? 'danger' : 'success'" size="small">
                    {{ currentPost.post_r3_false == 1 ? '是' : '否' }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="区域经验(R4):">
                  <el-input type="textarea" :rows="2" v-model="currentPost.post_r4" placeholder="请输入区域经验(R4)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="范围:">
                  <el-tag :type="currentPost.post_r4_scope == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.post_r4_scope == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="否决:">
                  <el-tag :type="currentPost.post_r4_false == 1 ? 'danger' : 'success'" size="small">
                    {{ currentPost.post_r4_false == 1 ? '是' : '否' }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="区域类型:">
                  <el-tag :type="currentPost.post_r4_type == 1 ? 'warning' : 'info'" size="small">
                    {{ currentPost.post_r4_type == 1 ? '海外' : '国内' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="总部经验(R5):">
                  <span>{{ currentPost.post_r5 }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="R5范围:">
                  <el-tag :type="currentPost.post_r5_scope == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.post_r5_scope == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="R5否决:">
                  <el-tag :type="currentPost.post_r5_false == 1 ? 'danger' : 'success'" size="small">
                    {{ currentPost.post_r5_false == 1 ? '是' : '否' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="工作年限(最小):">
                  <span>{{ currentPost.work_time_min }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="工作年限(最大):">
                  <span>{{ currentPost.work_time_max }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 学历和技能 -->
          <div class="form-section">
            <div class="section-title">学历和技能</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="第一学历:">
                  <span>{{ currentPost.first_degree }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="硕博要求:">
                  <span>{{ currentPost.shuobo_requirements }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="院校类型:">
                  <span>{{ ['不限','985','211','双一流','海外留学','QS200'][currentPost.school_type] || currentPost.school_type }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="毕业院校:">
                  <span>{{ currentPost.school }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="学科专业:">
                  <span>{{ currentPost.discipline }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="外语名称:">
                  <span>{{ currentPost.foreignlanguage_name }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="外语ID:">
                  <span>{{ currentPost.foreignlanguage_id }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="熟练程度:">
                  <span>{{ currentPost.proficiency }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="必备技能(任意/全部):">
                  <el-tag :type="currentPost.is_essentialskills == 1 ? 'success' : 'info'" size="small">
                    {{ currentPost.is_essentialskills == 1 ? '全部' : '任意' }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="必备技能关键词:">
                  <el-input type="textarea" :rows="2" v-model="currentPost.essentialskills_keywords" placeholder="请输入必备技能关键词"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 个人要求 -->
          <div class="form-section">
            <div class="section-title">个人要求</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="年龄范围:">
                  <span>{{ currentPost.min_age }} - {{ currentPost.max_age }} 岁</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别要求:">
                  <span>{{ ['不限','男','女'][currentPost.sex] || '不限' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <span></span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 活跃和工作状态 -->
          <div class="form-section" v-show="false">
            <div class="section-title">活跃和工作状态</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="活跃状态:">
                  <span>{{ ['不限','今天活跃','3天内活跃','7天内活跃','30天内活跃','最近三个月活跃','最近半年活跃','最近一年'][currentPost.active_status] || '不限' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工作状态:">
                  <span>{{ ['离职，正在找工作','在职，急寻新工作','在职，看看新机会','在职，暂无跳槽打算'][currentPost.work_status] || '不限' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- JD描述 -->
          <div class="form-section">
            <div class="section-title">JD描述</div>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="JD内容:">
                  <div class="jd-content">{{ currentPost.jd || '暂无JD描述' }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" :loading="postSaving" @click="savePostFields">保 存</el-button>
        <el-button size="medium" @click="postDetailHandleClose">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 网站详细统计弹窗 -->
    <el-dialog 
      title="网站详细统计" 
      :visible.sync="siteStatsDialogVisible" 
      width="900px"
      top="5vh">
      <div class="site-stats-header">
        <span>用户：<strong>{{ currentUserName }}</strong></span>
      </div>
      <el-table :data="siteStatsTableData" border stripe>
        <el-table-column prop="resTypeName" label="简历来源" width="180" align="center"></el-table-column>
        <el-table-column prop="day1" label="今日" width="230" align="center"></el-table-column>
        <el-table-column prop="day7" label="7日" width="230" align="center"></el-table-column>
        <el-table-column prop="day30" label="30日" width="230" align="center"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="siteStatsDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 权限设置弹窗 -->
    <el-dialog 
      title="权限设置" 
      :visible.sync="permissionDialogVisible" 
      width="50%" 
      :before-close="permissionHandleClose"
      top="5vh">
      <div class="permission-dialog-container">
        <!-- 上部：搜索框 -->
        <div class="search-section">
          <h4>添加用户</h4>
          <el-input
            v-model="permissionSearchKeyword"
            placeholder="搜索用户（手机号或姓名，至少2个字符）"
            clearable
            size="small"
            @input="searchUsers">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
          <div class="search-results" v-if="searchResults.length > 0">
            <el-table 
              :data="searchResults" 
              size="small" 
              style="margin-top: 10px"
              max-height="250">
              <el-table-column prop="loginUserId" label="用户ID" width="100"></el-table-column>
              <el-table-column prop="userName" label="账号" min-width="110"></el-table-column>
              <el-table-column prop="phonenumber" label="手机" width="120"></el-table-column>
              <el-table-column prop="nickName" label="姓名" width="100"></el-table-column>
              <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <el-button 
                    type="primary" 
                    size="mini" 
                    @click="addUserToPermission(scope.row)">
                    添加
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        
        <!-- 下部：权限表格 -->
        <div class="permission-table-section">
          <h4>已授权用户</h4>
          <el-table 
            :data="permissionTableData" 
            size="small"
            max-height="350"
            border>
            <el-table-column prop="loginUserId" label="Hirebot用户ID" width="120"></el-table-column>
            <el-table-column prop="userName" label="账号" min-width="120"></el-table-column>
            <el-table-column prop="phonenumber" label="手机" width="130"></el-table-column>
            <el-table-column prop="name" label="姓名" width="100"></el-table-column>
            <el-table-column label="简历查看" width="80" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.resumeView"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handlePermissionChange">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="岗位查看" width="80" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.postView"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handlePermissionChange">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" fixed="right" align="center">
              <template slot-scope="scope">
                <el-button 
                  type="danger" 
                  size="mini" 
                  @click="removeUserFromPermission(scope.$index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <input type="file" name="companyLogo" id="file0" class="displayN" multiple="multiple" @change="companyLogo($event)"
           ref="fileInputList" />
  </div>
</template>

<script>
import { mapState } from "vuex";

const USER_MODEL_DEFAULTS = {
  listModel: 'doubao-seed-2-0-mini-260428',
  detailModel: 'doubao-seed-2-0-mini-260428',
  apiKey: 'd974b5f3-d209-40f7-a4ce-b60270a8cb3e'
};

export default {
  computed: {
    ...mapState([
      "tabShopIndex",
      "biaobaiqiangPage",
      "biaobaiqiangPageSize",
      "xiaoshoubiaoPage",
      "xiaoshoubiaoPageSize"
    ]),
    currentPageData() {
      // 先过滤数据
      let filteredData = this.tableData.filter(item => {
        if (!this.searchUserName) return true;
        const keyword = this.searchUserName.toLowerCase();
        const userName = (item.userName || '').toLowerCase();
        const nickName = (item.nickName || '').toLowerCase();
        return userName.includes(keyword) || nickName.includes(keyword);
      });
      
      // 日活筛选
      if (this.todayActiveFilter) {
        filteredData = filteredData.filter(item => {
          return item.pv1 && parseInt(item.pv1) > 0;
        });
      }
      
      // 月活筛选
      if (this.monthActiveFilter) {
        filteredData = filteredData.filter(item => {
          return item.pv30 && parseInt(item.pv30) > 0;
        });
      }
      
      // 再分页
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return filteredData.slice(start, end);
    },
    filteredTotal() {
      let filteredData = this.tableData.filter(item => {
        if (!this.searchUserName) return true;
        const keyword = this.searchUserName.toLowerCase();
        const userName = (item.userName || '').toLowerCase();
        const nickName = (item.nickName || '').toLowerCase();
        return userName.includes(keyword) || nickName.includes(keyword);
      });
      
      // 日活筛选
      if (this.todayActiveFilter) {
        filteredData = filteredData.filter(item => {
          return item.pv1 && parseInt(item.pv1) > 0;
        });
      }
      
      // 月活筛选
      if (this.monthActiveFilter) {
        filteredData = filteredData.filter(item => {
          return item.pv30 && parseInt(item.pv30) > 0;
        });
      }
      
      return filteredData.length;
    }
  },
  watch: {
    tabShopIndex: function () {
      this.activeName = this.tabShopIndex;
      console.log(this.activeName);
      this.getData();
    },
    biaobaiqiangPage: function (page) {
      this.$store.commit("biaobaiqiangPage", page);
      this.getData();
    },
    biaobaiqiangPageSize: function (pageSize) {
      this.$store.commit("biaobaiqiangPageSize", pageSize);
      this.getData();
    },
    xiaoshoubiaoPage: function (page) {
      this.$store.commit("xiaoshoubiaoPage", page);
      this.getxsData();
    },
    xiaoshoubiaoPageSize: function (pageSize) {
      this.$store.commit("xiaoshoubiaoPageSize", pageSize);
      this.getxsData();
    }
  },
  data() {
    return {
      is_status: -1,
      loading: false,
      activeName: "1",
      searchForm: {
        challenges_id: "",
      },
      tableData: [],
      total: 0,
      todayActiveCount:0,
      monthActiveCount:0,
      addDialogVisible: false,
      modelOptions: [],
      originalBalance: "",
      logVisible: false,
      logLoading: false,
      logTitle: "收支明细",
      logUserId: null,
      logRows: [],
      logPage: 1,
      logPageSize: 20,
      logTotal: 0,
      balanceChangeVisible: false,
      balanceChangeLoading: false,
      balanceChangeTitle: "充值",
      balanceChangeMode: "recharge",
      balanceChangeUserId: null,
      balanceChangeCurrent: "",
      balanceChangeAmount: "",
      addForm: {
        userId:null,
        userName:"",
        nickName:"",
        company:"",
        job:"",
        email:"",
        expireDate:"",
        searchMax:100,
        searchCount:0,
        siteQuota:5000,
        resumedbShow:1,
        resumedbEnable:0,
        resumeDelete:0,
        resumeExport:0,
        listModel: USER_MODEL_DEFAULTS.listModel,
        detailModel: USER_MODEL_DEFAULTS.detailModel,
        apiKey: USER_MODEL_DEFAULTS.apiKey,
        balance: "",
        phoneNumber:"",
        password:"Hirebot",
        status:0
      },
      rules: {
        userName: [{ required: true, message: "请输入登录账号", trigger: "blur" }],
        nickName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司", trigger: "blur" }],
        job: [{ required: true, message: "请输入职务", trigger: "blur" }],
        searchMax: [{ required: true, message: "请输入限额", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      imgStatus: "",
      imgFile: "",
      id: "",
      xsaddDialogVisible: false,
      xstableData: [],
      xssearchForm: {
        time: ""
      },
      xstotal: 0,
      SFlist: [],
      CSlist: [],
      imgIndex: 0,
      Userlist: [],
      isAdd: false,
      SSlist: [],
      currentPage: 1,
      pageSize: 10,
      searchUserName: '',
      todayActiveFilter: false,
      monthActiveFilter: false,
      // 岗位列表弹窗相关
      postsDialogVisible: false,
      postsList: [],
      postsLoading: false,
      currentUserName: '',
      // 岗位详情弹窗相关
      postDetailDialogVisible: false,
      currentPost: {},
      postSaving: false,
      // 网站统计弹窗相关
      siteStatsDialogVisible: false,
      siteStatsTableData: [],
      resTypeMapping: {
        1: { name: '猎聘猎头版-列表', typeName: '列表' },
        2: { name: '猎聘猎头版-详情', typeName: '详情' },
        3: { name: '智联-列表', typeName: '列表' },
        4: { name: '智联-详情', typeName: '详情' },
        5: { name: '猎聘企业版-列表', typeName: '列表' },
        6: { name: '猎聘企业版-详情', typeName: '详情' },
        7: { name: '前程无忧-列表', typeName: '列表' },
        8: { name: '前程无忧-详情', typeName: '详情' },
        9: { name: 'BOSS-列表', typeName: '列表' },
        10: { name: 'BOSS-详情', typeName: '详情' },
        11: { name: 'maimai-列表', typeName: '列表' },
        12: { name: 'maimai-详情', typeName: '详情' },
        13: { name: '才库-列表', typeName: '列表' },
        14: { name: '才库-详情', typeName: '详情' }
      },
      // 权限设置相关
      permissionDialogVisible: false,
      currentPermissionUser: null,
      permissionSearchKeyword: '',
      searchResults: [],
      permissionTableData: []
    };
  },
  created() {
    this.$store.commit("biaobaiqiangPage", 1);
    this.$store.commit("biaobaiqiangPageSize", 10);
    this.getData();
    this.loadModelOptions();
  },
  methods: {
    async loadModelOptions() {
      const res = await this.$api.crudselectListByMap({
        page: 1,
        pagesize: 500,
        table: "model_price",
        params: {}
      });
      const body = res && res.data ? res.data : {};
      this.modelOptions = body.data || [];
    },
    openBalanceChange(row, mode) {
      this.balanceChangeMode = mode;
      this.balanceChangeTitle = mode === "refund" ? "退款" : "充值";
      this.balanceChangeUserId = row.userId;
      this.balanceChangeCurrent = row.balance == null ? "0" : String(row.balance);
      this.balanceChangeAmount = "";
      this.balanceChangeVisible = true;
    },
    async submitBalanceChange() {
      const amount = String(this.balanceChangeAmount || "").trim();
      if (!/^(?:0|[1-9]\d*)(?:\.\d+)?$/.test(amount) || Number(amount) <= 0) {
        this.$message.error("请输入大于 0 的金额");
        return;
      }
      this.balanceChangeLoading = true;
      const api = this.balanceChangeMode === "refund"
        ? this.$api.hirebotuser_refund_balance
        : this.$api.hirebotuser_recharge_balance;
      const res = await api({
        userId: this.balanceChangeUserId,
        amount: amount
      });
      this.balanceChangeLoading = false;
      if (res.result == 1) {
        this.$message.success(this.balanceChangeTitle + "成功");
        this.balanceChangeVisible = false;
        this.getData();
      } else {
        this.$message.error(res.msg || this.balanceChangeTitle + "失败");
      }
    },
    openBalanceLogs(row) {
      this.logUserId = row.userId;
      this.logTitle = (row.userName || "") + " 收支明细";
      this.logPage = 1;
      this.logVisible = true;
      this.fetchBalanceLogs();
    },
    changeLogPage(page) {
      this.logPage = page;
      this.fetchBalanceLogs();
    },
    async fetchBalanceLogs() {
      this.logLoading = true;
      const res = await this.$api.hirebotuser_balance_logs({
        userId: this.logUserId,
        pageNum: this.logPage,
        pageSize: this.logPageSize
      });
      const data = res && res.data ? res.data : {};
      this.logRows = data.rows || [];
      this.logTotal = data.total || 0;
      this.logLoading = false;
    },
    async getData() {
      this.loading = true;
      const res = await this.$api.hirebotuser_list();
      console.log(res);
      this.tableData = res.data ? res.data : [];
      this.total = res.total
      this.loading = false;
      this.todayActiveCount=res.todayActiveCount
      this.monthActiveCount=res.monthActiveCount
    },
    async changeUserStatus(event,row){
      this.addForm = { ...row }
      this.addForm.status=row.status==1?0:1
      const res = await this.$api.hirebotuser_update({
        ...this.addForm
      }).then(()=>{
        row.status=this.addForm.status
      })
      console.log(res)
    },
    async changeUserResumedbShow(event,row){
      this.addForm = { ...row }
      this.addForm.resumedbShow=row.resumedbShow==1?0:1
      const res = await this.$api.hirebotuser_update({
        ...this.addForm
      }).then(()=>{
        row.resumedbShow=this.addForm.resumedbShow
      })
      console.log(res)
    },
    async changeUserResumedbEnable(event,row){
      this.addForm = { ...row }
      this.addForm.resumedbEnable=row.resumedbEnable==1?0:1
      const res = await this.$api.hirebotuser_update({
        ...this.addForm
      }).then(()=>{
        row.resumedbEnable=this.addForm.resumedbEnable
      })
      console.log(res)
    },
    async changeUserAiEnable(event,row){
      try {
        this.addForm = { ...row }
        this.addForm.aiEnable = row.aiEnable == 1 ? 0 : 1
        const res = await this.$api.hirebotuser_update({
          ...this.addForm
        })
        if (res.result == 1) {
          row.aiEnable = this.addForm.aiEnable
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          // 刷新列表以确保数据一致性
          this.getData()
        } else {
          this.$message.error(res.msg || '更新失败')
        }
      } catch (error) {
        console.error('更新AI状态失败:', error)
        this.$message.error('更新失败，请重试')
      }
    },
    async changeUserResumeDelete(event,row){
      try {
        this.addForm = { ...row }
        this.addForm.resumeDelete = row.resumeDelete == 1 ? 0 : 1
        const res = await this.$api.hirebotuser_update({
          ...this.addForm
        })
        if (res.result == 1) {
          row.resumeDelete = this.addForm.resumeDelete
          this.$message({
            message: '简历删除权限更新成功',
            type: 'success'
          })
          this.getData()
        } else {
          this.$message.error(res.msg || '更新失败')
        }
      } catch (error) {
        console.error('更新简历删除权限失败:', error)
        this.$message.error('更新失败，请重试')
      }
    },
    async changeUserResumeExport(event,row){
      try {
        this.addForm = { ...row }
        this.addForm.resumeExport = row.resumeExport == 1 ? 0 : 1
        const res = await this.$api.hirebotuser_update({
          ...this.addForm
        })
        if (res.result == 1) {
          row.resumeExport = this.addForm.resumeExport
          this.$message({
            message: '简历导出权限更新成功',
            type: 'success'
          })
          this.getData()
        } else {
          this.$message.error(res.msg || '更新失败')
        }
      } catch (error) {
        console.error('更新简历导出权限失败:', error)
        this.$message.error('更新失败，请重试')
      }
    },
    changeSF() {
      this.getCSData()
    },
    xssearchOnSubmit() {
      this.getxsData();
    },
    addEditGuanliyuan(row) {
      this.id = row.id;
      this.addForm.user_name = row.store_username;
      this.addForm.status = row.store_userstatus.toString();
      this.addDialogVisible = true;
    },
    seeXiaoshou(row) {
      this.id = row.id;
      this.xsaddDialogVisible = true;
    },
    xsaddHandleClose() {
      this.xsaddDialogVisible = false;
    },
    // 开关（显示/隐藏）
    async changeKG2(row) {
      console.log(row);
      const res = await this.$api.store_setflag({
        id: row.id,
        flag: row.myFlagship == true ? "1" : "0"
      });
      console.log(res);
      if (res.data.result == 1) {
        this.$message({
          message: res.data.msg,
          type: "success"
        });
        this.getData();
      }
    },
    async changeKG(row) {
      console.log(row);
      const res = await this.$api.store_setstatus({
        id: row.id,
        status: row.myIs_status == true ? "1" : "0"
      });
      if (res.data.result == 1) {
        this.$message({
          message: res.data.msg,
          type: "success"
        });
        this.addDialogVisible = false;
        this.getData();
      }
    },
    toEdit(row) {
      // this.addForm = { ...row }
      this.addForm.userId=row.userId
      this.addForm.userName=row.userName
      this.addForm.nickName=row.nickName
      this.addForm.email=row.email
      this.addForm.phoneNumber=row.phonenumber
      this.addForm.status=row.status

      this.addForm.company=row.company
      this.addForm.job=row.job
      this.addForm.expireDate=row.expireDate
      this.addForm.searchMax=row.searchMax
      this.addForm.searchCount=row.searchCount
      this.addForm.siteQuota=row.siteQuota == null ? 5000 : row.siteQuota
      this.addForm.resumedbShow=row.resumedbShow
      this.addForm.resumedbEnable=row.resumedbEnable
      this.addForm.resumeDelete=row.resumeDelete
      this.addForm.resumeExport=row.resumeExport
      this.addForm.listModel=row.listModel || USER_MODEL_DEFAULTS.listModel
      this.addForm.detailModel=row.detailModel || USER_MODEL_DEFAULTS.detailModel
      this.addForm.apiKey=row.apiKey || USER_MODEL_DEFAULTS.apiKey
      this.addForm.balance=row.balance == null ? "0" : String(row.balance)
      this.originalBalance=this.addForm.balance

      this.isAdd = false
      this.addDialogVisible = true
    },
    toResetPass(row){
      this.$prompt('请输入密码', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6,}/,
        inputErrorMessage: '密码至少6位'
      }).then(({ value }) => {
        this.$api.hirebotuser_resetpass({
          userName:row.userName,
          newPassword:value
        }).then(()=>{
          this.$message({
            type: 'success',
            message: '修改成功'
          });
        })
      }).catch(() => {

      });
    },
    async toDel(row) {
      const res = await this.$api.del_swiper({
        id: row.id
      })
      if (res.result == 1) {
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.getData();
      }
    },
    tabsHandleClick(tab) {
      console.log(tab.index);
      this.$store.commit("tabShopIndex", (Number(tab.index) + 1).toString());
    },
    searchOnSubmit() {
      console.log(this.searchForm);
    },
    applyModelDefaults() {
      this.addForm.listModel = USER_MODEL_DEFAULTS.listModel
      this.addForm.detailModel = USER_MODEL_DEFAULTS.detailModel
      this.addForm.apiKey = USER_MODEL_DEFAULTS.apiKey
    },
    AddSaishi() {
      this.isAdd = true;
      for (const key in this.addForm) {
        if (key != 'password') {
          this.$set(this.addForm, key, "");
        }
      }
      this.addForm.password="Hirebot2024"
      this.addForm.searchCount=0
      this.addForm.searchMax=100
      this.addForm.siteQuota=5000
      this.addForm.resumedbShow=1
      this.addForm.resumedbEnable=0
      this.addForm.resumeDelete=0
      this.addForm.resumeExport=0
      this.applyModelDefaults()
      this.addDialogVisible = true;
    },
    addHandleClose() {
      this.addDialogVisible = false;
    },
    tabEdit(row) {
      console.log(row);
      this.addForm = { ...row };
      this.addForm.phoneNumber=row.phonenumber
      this.addDialogVisible = true;
    },
    async tabDel(row) {
      console.log(row);
      const res = await this.$api.categoryDel(row.id);
      if (res) {
        this.$message({
          message: res.msg,
          type: "success"
        });
        setTimeout(() => {
          this.getData();
        }, 500);
      } else {
        this.$message.error(res.msg);
      }
    },
    resumedbShowChange(row){
      this.addForm.resumedbShow=row
    },
    AddOnSubmit(formName) {
      console.log(this.addForm);
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.isAdd) {
            // 新增
            const res = await this.$api.hirebotuser_add({
              ...this.addForm,
            });
            if (res.result == 1) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.addDialogVisible = false;
              this.getData();
            } else {
              this.$message({
                message: res.msg,
              });
            }
          } else {
            // 修改
            const res = await this.$api.hirebotuser_update({
              ...this.addForm
            });
            if (res.result == 1) {
              if (Number(this.addForm.balance) !== Number(this.originalBalance)) {
                const balanceRes = await this.$api.hirebotuser_adjust_balance({
                  userId: this.addForm.userId,
                  balance: this.addForm.balance
                });
                if (balanceRes.result != 1) {
                  this.$message.error(balanceRes.msg || "余额保存失败");
                  this.getData();
                  return;
                }
              }
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.addDialogVisible = false;
              this.getData();
            }else {
              this.$message({
                message: res.msg,
              });
            }
          }

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除图片
    delImg(val, i = 0) {
      if (val == "details_pic") {
        if (this.addForm.details_pic[i].name != '') {
          this.addForm.details_pic.splice(i, 1)
        }
      } else if (val == "tb") {
        this.$set(this.addForm,'pic','')
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    xshandleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.$store.commit("xiaoshoubiaoPageSize", val);
    },
    xshandleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.$store.commit("xiaoshoubiaoPage", val);
    },
    // 上传图片
    companyList(val, i = 0) {
      this.imgIndex = i;
      this.imgStatus = val;
      this.$refs.fileInputList.click();
    },
    //将文件转为blob类型
    readFileAsBuffer(file) {
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.readAsDataURL(file);
        reader.onload = function () {
          const base64File = reader.result.replace(
              /^data:\w+\/\w+;base64,/,
              ""
          );
          resolve(new window.OSS.Buffer(base64File, "base64"));
        };
      });
    },
    async companyLogo(event) {
      const that = this;
      var file = event.target.files[0];
      var fileSize = file.size; //文件大小
      var filetType = file.type; //文件类型
      //创建文件读取对象
      // console.log(file);
      if (fileSize <= 10240 * 1024) {
        if (
            filetType == "image/png" ||
            filetType == "image/jpeg" ||
            filetType == "image/gif"
        ) {
          var file_re = await this.readFileAsBuffer(file);
          // console.log(this.imgFile);
          const res = await this.$api.aliyun_osssts()
          let client = new window.OSS.Wrapper({
            secure:true,
            region:res.region, //oss地址
            accessKeyId: res.accessKeyId, //ak
            accessKeySecret: res.accessKeySecret, //secret
            stsToken: res.stsToken,
            bucket:res.bucket, //oss名字
          });
          var imgtype = file.type.substr(6, 4);
          var store = `${new Date().getTime()}.${imgtype}`;
          console.log(store);
          client.put(store, file_re).then(() => {
            //这个结果就是url
            var a = client.signatureUrl(store);
            if (a.match('^http://')) {
              a = a.replace("http://", "https://")
            }
            this.oss_imgurl = a;
            console.log(a);
            if(this.imgStatus == 'tb'){
              this.$set(this.addForm,'pic',a)
            }
          });
          that.$refs.fileInputList.value = "";
        } else {
          this.$message.error("图片格式不正确");
        }
      } else {
        this.$message.error("图片大小不正确");
      }
    },
    // 添加搜索处理方法
    handleSearch() {
      this.currentPage = 1; // 搜索时重置到第一页
    },
    toggleTodayActiveFilter() {
      this.todayActiveFilter = !this.todayActiveFilter;
      this.currentPage = 1; // 筛选时重置到第一页
    },
    toggleMonthActiveFilter() {
      this.monthActiveFilter = !this.monthActiveFilter;
      this.currentPage = 1; // 筛选时重置到第一页
    },
    // 显示岗位列表
    async showPostsDetail(row) {
      if (!row.onlinePostCount || row.onlinePostCount === 0) {
        this.$message.info('该用户暂无在招岗位');
        return;
      }
      
      this.currentUserName = row.userName;
      this.postsDialogVisible = true;
      this.postsLoading = true;
      
      try {
        const res = await this.$api.hirebotuser_postslist({
          loginUserId: row.loginUserId
        });
        
        if (res.result == 1) {
          this.postsList = res.data || [];
        } else {
          this.$message.error(res.msg || '获取岗位列表失败');
          this.postsList = [];
        }
      } catch (error) {
        console.error('获取岗位列表失败:', error);
        this.$message.error('获取岗位列表失败');
        this.postsList = [];
      } finally {
        this.postsLoading = false;
      }
    },
    // 关闭岗位列表弹窗
    postsHandleClose() {
      this.postsDialogVisible = false;
      this.postsList = [];
      this.currentUserName = '';
    },
    // 显示单个岗位详情
    showPostDetail(post) {
      this.currentPost = { ...post };
      this.postDetailDialogVisible = true;
    },
    // 关闭岗位详情弹窗
    postDetailHandleClose() {
      this.postDetailDialogVisible = false;
      this.currentPost = {};
      this.postSaving = false;
    },
    // 保存岗位可编辑字段
    async savePostFields() {
      if (!this.currentPost || !this.currentPost.post_id) {
        this.$message.error('岗位ID缺失，无法保存');
        return;
      }
      this.postSaving = true;
      try {
        const res = await this.$api.crudupdatebymap({
          table: 'com_postnavigation',
          whereMap: {
            post_id: this.currentPost.post_id
          },
          values: {
            post_r1: this.currentPost.post_r1 || '',
            post_r2: this.currentPost.post_r2 || '',
            post_r3: this.currentPost.post_r3 || '',
            post_r4: this.currentPost.post_r4 || '',
            target_company: this.currentPost.target_company || '',
            postname_keywords: this.currentPost.postname_keywords || '',
            jobtitle_keywords: this.currentPost.jobtitle_keywords || '',
            essentialskills_keywords: this.currentPost.essentialskills_keywords || ''
          }
        });
        if (res.data && res.data.result == 1) {
          const idx = this.postsList.findIndex(item => item.post_id === this.currentPost.post_id);
          if (idx > -1) {
            this.$set(this.postsList, idx, { ...this.postsList[idx], ...this.currentPost });
          }
          this.$message.success('保存成功');
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      } catch (error) {
        console.error('保存岗位字段失败:', error);
        this.$message.error('保存失败，请重试');
      } finally {
        this.postSaving = false;
      }
    },
    // 格式化日期时间
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return '';
      try {
        const date = new Date(dateTimeStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return dateTimeStr;
      }
    },
    // 判断是否有网站统计数据
    hasSiteStats(row) {
      return row.siteStats && 
             row.siteStats.today && 
             Object.keys(row.siteStats.today).length > 0;
    },
    // 格式化网站统计显示（紧凑格式，只显示详情数据）
    formatSiteStats(siteStats) {
      if (!siteStats || !siteStats.today) return '-';
      
      const today = siteStats.today;
      const parts = [];
      
      // 按固定顺序显示（只显示详情）
      const order = ['猎聘企业版', '智联', '猎聘猎头版', '前程无忧', 'BOSS','脉脉','才库'];
      const shortNames = {
        '猎聘企业版': '猎聘企',
        '智联': '智联',
        '猎聘猎头版': '猎聘猎',
        '前程无忧': '前程',
        'BOSS': 'BOSS',
        '脉脉': '脉脉',
        '才库': '才库'
      };
      
      order.forEach(site => {
        if (today[site] && today[site] > 0) {
          parts.push(`${shortNames[site]}(${today[site]})`);
        }
      });
      
      return parts.join(' ') || '-';
    },
    // 显示详细统计弹窗（只显示详情数据：res_type 2,4,6,8,10）
    showSiteStatsDetail(row) {
      this.currentUserName = row.userName;
      this.siteStatsDialogVisible = true;
      
      // 转换为表格数据（只显示偶数res_type：详情）
      const detail = row.siteStatsDetail || {};
      this.siteStatsTableData = [];
      
      // 只遍历详情类型（偶数res_type）
      const detailResTypes = [2, 4, 6, 8, 10,12];
      detailResTypes.forEach(resType => {
        const stats = detail[resType];
        if (stats && (stats.day1 > 0 || stats.day7 > 0 || stats.day30 > 0)) {
          this.siteStatsTableData.push({
            resType: resType,
            resTypeName: this.resTypeMapping[resType].name,
            typeName: this.resTypeMapping[resType].typeName,
            day1: stats.day1 || 0,
            day7: stats.day7 || 0,
            day30: stats.day30 || 0
          });
        }
      });
      
      // 如果没有数据，显示提示
      if (this.siteStatsTableData.length === 0) {
        this.$message.info('暂无详细统计数据');
        this.siteStatsDialogVisible = false;
      }
    },
    
    // ========== 权限设置相关方法 ==========
    // 显示权限设置弹窗
    async showPermissionDialog(row) {
      console.log('=== 打开权限设置弹窗 ===', row);
      this.currentPermissionUser = row;
      this.permissionTableData = [];
      
      // 从接口获取最新的权限配置（包含最新的 nick_name）
      try {
        console.log('调用接口获取权限配置，userId:', row.userId);
        const response = await this.$api.hirebotuser_my_scope_users({ userId: row.userId });
        console.log('接口返回数据:', response);
        
        // 注意：这个项目的 API 返回格式是 result: 1，不是 code: 200
        if (response.result === 1 && response.data) {
          this.permissionTableData = response.data.map(item => ({
            userId: item.userId,
            loginUserId: item.loginUserId,
            userName: item.userName || '',
            phonenumber: item.phonenumber || '',
            name: item.name || '',  // 这里是从数据库获取的最新 nick_name
            resumeView: item.resumeView || 0,
            resumeEdit: item.resumeEdit || 0,
            resumeDelete: item.resumeDelete || 0,
            resumeExport: item.resumeExport || 0,
            postView: item.postView || 0
          }));
          console.log('权限表格数据:', this.permissionTableData);
        } else {
          console.warn('接口返回格式不正确或无数据:', response);
        }
      } catch (e) {
        console.error('获取权限配置失败', e);
        this.permissionTableData = [];
      }
      
      this.permissionDialogVisible = true;
      this.permissionSearchKeyword = '';
      this.searchResults = [];
    },
    
    // 关闭权限设置弹窗
    permissionHandleClose() {
      this.permissionDialogVisible = false;
      this.currentPermissionUser = null;
      this.permissionSearchKeyword = '';
      this.searchResults = [];
      this.permissionTableData = [];
    },
    
    // 获取权限数量
    getPermissionCount(row) {
      if (!row.myScope) return 0;
      try {
        const scopeConfig = JSON.parse(row.myScope);
        return scopeConfig.length;
      } catch (e) {
        return 0;
      }
    },
    
    // 搜索用户
    searchUsers() {
      const keyword = this.permissionSearchKeyword.trim();
      
      if (keyword.length < 2) {
        this.searchResults = [];
        return;
      }
      
      // 从tableData中搜索（排除当前用户）
      this.searchResults = this.tableData.filter(user => {
        // 排除当前编辑的用户
        if (user.userId === this.currentPermissionUser.userId) {
          return false;
        }
        
        // 排除已经在权限表中的用户
        const existsInTable = this.permissionTableData.some(
          item => item.userId === user.userId
        );
        if (existsInTable) {
          return false;
        }
        
        // 匹配手机号或姓名
        return (user.phonenumber && user.phonenumber.includes(keyword)) ||
               (user.nickName && user.nickName.includes(keyword));
      }).slice(0, 10); // 最多显示10条
    },
    
    // 添加用户到权限列表
    addUserToPermission(user) {
      // 检查是否已存在
      const exists = this.permissionTableData.some(
        item => item.userId === user.userId
      );
      
      if (exists) {
        this.$message.warning('该用户已在列表中');
        return;
      }
      
      // 添加到权限表，简历查看默认开启
      this.permissionTableData.push({
        userId: user.userId,
        loginUserId: user.loginUserId,
        userName: user.userName,
        phonenumber: user.phonenumber,
        name: user.nickName,
        resumeView: 1,  // 默认开启简历查看
        resumeEdit: 0,
        resumeDelete: 0,
        resumeExport: 0,
        postView: 0
      });
      
      // 清空搜索
      this.permissionSearchKeyword = '';
      this.searchResults = [];
      
      // 立即保存
      this.handlePermissionChange();
    },
    
    // 从权限列表移除用户
    removeUserFromPermission(index) {
      this.$confirm('确定要移除该用户的权限吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.permissionTableData.splice(index, 1);
        this.handlePermissionChange();
        this.$message.success('移除成功');
      }).catch(() => {});
    },
    
    // 权限开关变化（自动保存）
    handlePermissionChange() {
      // 这里可以选择自动保存或者等待用户点击保存按钮
      // 为了用户体验，我们实现自动保存
      this.savePermissionConfig(true);
    },
    
    // 保存权限配置
    async savePermissionConfig(silent = false) {
      try {
        // 构建权限配置JSON
        const myScope = JSON.stringify(this.permissionTableData);
        
        // 调用更新接口
        const response = await this.$api.hirebotuser_update({
          userId: this.currentPermissionUser.userId,
          userName: this.currentPermissionUser.userName,
          nickName: this.currentPermissionUser.nickName,
          email: this.currentPermissionUser.email,
          phonenumber: this.currentPermissionUser.phonenumber,
          status: this.currentPermissionUser.status,
          company: this.currentPermissionUser.company,
          job: this.currentPermissionUser.job,
          expireDate: this.currentPermissionUser.expireDate,
          searchMax: this.currentPermissionUser.searchMax,
          searchCount: this.currentPermissionUser.searchCount,
          siteQuota: this.currentPermissionUser.siteQuota,
          resumedbShow: this.currentPermissionUser.resumedbShow,
          resumedbEnable: this.currentPermissionUser.resumedbEnable,
          aiEnable: this.currentPermissionUser.aiEnable,
          myScope: myScope
        });
        
        if (response.result == 1) {
          // 更新本地数据
          this.currentPermissionUser.myScope = myScope;
          
          if (!silent) {
            this.$message.success('保存成功');
            this.permissionDialogVisible = false;
          }
          
          // 刷新列表
          this.getData();
        } else {
          this.$message.error(response.msg || '保存失败');
        }
      } catch (error) {
        console.error('保存权限配置失败', error);
        this.$message.error('保存失败：' + (error.message || '未知错误'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;

  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
    padding-bottom: 20px;
  }
}

.myForm {
  ::v-deep  .el-form-item__label {
    font-size: 12px;
  }

  ::v-deep  .el-form-item {
    margin-right: 30px;
    margin-bottom: 0;
    vertical-align: middle;
  }
}

.tit1 {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.myTable {
  .xiala {
    padding: 10px 20px;

    .item {
      font-size: 12px;
      display: flex;
    }
  }

  margin-top: 10px;

  ::v-deep  .vxe-table--render-default .vxe-body--column {
    line-height: 14px;
    vertical-align: middle;
  }

  ::v-deep  .vxe-cell--label {
    font-size: 12px;
  }

  ::v-deep  .vxe-cell--title {
    font-size: 12px;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.nav2 {
  margin: 18px 0;
  background: #fff;
  border-radius: 6px;
  padding: 24px;

  .myForm {
    ::v-deep  .el-form-item__label {
      font-size: 12px;
    }

    ::v-deep  .el-form-item {
      margin-right: 30px;
      margin-bottom: 0;
      vertical-align: middle;
    }
  }

  .tit1 {
    margin-top: 10px;
  }

  .myTable {
    margin-top: 10px;

    ::v-deep  .vxe-table--render-default .vxe-body--column {
      line-height: 14px;
      vertical-align: middle;
    }

    ::v-deep  .vxe-cell--label {
      font-size: 12px;
    }

    ::v-deep  .vxe-cell--title {
      font-size: 12px;
    }

    .flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.myAddForm {
  ::v-deep  .el-select {
    width: 100%;
  }

  ::v-deep  .el-form-item__label {
    font-size: 12px;
    width: 130px !important;
  }

  ::v-deep  .el-form-item__content {
    margin-left: 130px !important;
  }

  ::v-deep  .el-radio__label {
    font-size: 12px;
  }

  ::v-deep  .el-button {
    width: 100%;
  }

}

.fenye {
  margin-top: 16px;
}

.displayN {
  display: none;
}

.myImg {
  position: relative;
  width: 60px;
  height: 60px;
  display: inline-block;
  margin-right: 12px;

  .closeBtn {
    position: absolute;
    top: -6px;
    right: -4px;
    width: 20px;
    height: 20px;

    .el-button {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  ::v-deep  .image-slot {
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fafafa;
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .el-icon-picture-outline {
      font-size: 20px;
    }
  }

  .myImg {
    position: relative;
    width: 60px;
    height: 60px;
    display: inline-block;
    margin-right: 12px;

    .closeBtn {
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;

      .el-button {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    ::v-deep  .image-slot {
      border: 1px solid #ddd;
      border-radius: 4px;
      background-color: #fafafa;
      width: 58px;
      height: 58px;
      display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .el-icon-picture-outline {
          font-size: 20px;
        }
      }
    }
  }

// 激活筛选标签样式
::v-deep .active-filter {
  background-color: #409eff !important;
  color: white !important;
  border-color: #409eff !important;
}

// 岗位列表弹窗样式
.posts-dialog-header {
  padding: 10px 0;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #606266;
}

// 网站统计弹窗头部样式
.site-stats-header {
  padding: 10px 0;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #606266;
}

// 岗位详情弹窗样式
.post-detail-container {
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px;
  
  .post-detail-form {
    .form-section {
      margin-bottom: 20px;
      padding: 15px;
      background-color: #f9f9f9;
      border-radius: 4px;
      border-left: 3px solid #409eff;
      
      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 15px;
        padding-bottom: 8px;
        border-bottom: 1px solid #dcdfe6;
      }
      
      ::v-deep .el-form-item {
        margin-bottom: 10px;
        
        .el-form-item__label {
          font-weight: 500;
          color: #606266;
          text-align: right;
          padding-right: 12px;
        }
        
        .el-form-item__content {
          line-height: 32px;
        }
        
        span {
          color: #303133;
          word-break: break-all;
          
          &.highlight-text {
            color: #409eff;
            font-weight: 600;
          }
          
          &.danger-text {
            color: #f56c6c;
            font-weight: 500;
          }
        }
      }
    }
    
    .jd-content {
      padding: 10px;
      background-color: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      min-height: 100px;
      white-space: pre-wrap;
      word-break: break-all;
      line-height: 1.6;
      color: #606266;
    }
  }
}

// 自定义滚动条
.post-detail-container::-webkit-scrollbar {
  width: 6px;
}

.post-detail-container::-webkit-scrollbar-thumb {
  background-color: #dcdfe6;
  border-radius: 3px;
}

.post-detail-container::-webkit-scrollbar-track {
  background-color: #f5f7fa;
}

// 权限设置弹窗样式
.permission-dialog-container {
  .search-section {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
    
    h4 {
      margin: 0 0 15px 0;
      color: #303133;
      font-size: 16px;
      font-weight: 500;
    }
    
    .search-results {
      margin-top: 15px;
    }
  }
  
  .permission-table-section {
    h4 {
      margin: 0 0 15px 0;
      color: #303133;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>

